export const deepCopy = (obj: Object): Object => JSON.parse(JSON.stringify(obj));

export const copyLink = (link: string): void => {
  const input: HTMLInputElement = document.createElement('input');
  input.setAttribute('value', link);
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
};
